<template>
    <div class="list">
      <div class="breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
          <Breadcrumb-item>续费数据列表</Breadcrumb-item>
        </Breadcrumb>
      </div>
      <div class="search" @keyup.enter="search">
        <Form :show-message="false" labe-position="left">
          <Row>
            <Col :span="8">
              <Form-item label="时间范围：" :label-width="80">
                <Row>
                  <Col :span="11">
                    <Date-picker type="datetime" v-model="startTimeStr" format="yyyy-MM-dd" placeholder="请选择日期"
                    @on-change="startTimeDateChange" style="width: 100%;"></Date-picker>
                  </Col>
                  <Col :span="1" style="text-align: center;">-</Col>
                  <Col :span="11">
                    <Date-picker type="datetime" v-model="endTimeStr" format="yyyy-MM-dd" placeholder="请选择日期"
                    @on-change="endTimeDateChange" style="width: 100%;"></Date-picker>
                  </Col>
                </Row>
              </Form-item>
            </Col>
            <Col :span="2" align="right">
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                      @click="search">搜索
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <List ref="dataList" :tableColumns="title" listUrl="/userStudyAdviserLog/list"
            :params="queryParam" :onLoading="onLoading"></List>
    </div>
</template>

<script>
  import dates from '@/tools/date/dates.js'
import Row from 'iview/src/components/grid/row';
  export default {
    name: 'RenewDataList',
    data () {
      return {
        searchLoading: false,
        queryParam: {
          startTime: '',
          endTime: '',
          status: 1,
        },
        startTimeStr: '',
        endTimeStr: '',
        title: [
          {
            title: '学导ID/姓名',
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.studyAdviserId + '-' + row.nickname)
            }
          },
          {
            title: '结课学生数',
            align: 'center',
            key: 'overClassUserNum'
          },
          {
            title: '结课续费学生数',
            align: 'center',
            key: 'overRenewUserNum'
          },
          {
            title: '续费数',
            align: 'center',
            key: 'renewUserNum'
          }
        ]
      }
    },
    created: function () {
      this.startTimeStr = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '1'
      this.endTimeStr = dates.format(Date.now(), 'YYYY-MM-DD')
      this.queryParam.startTime = Date.parse(this.startTimeStr) / 1000
      this.queryParam.endTime = Date.parse(this.endTimeStr) / 1000
    },
    methods: {
      startTimeDateChange (value) {
        if (value) {
          this.queryParam.startTime = (Date.parse(new Date(value)) / 1000) - 28800
        } else {
          this.queryParam.startTime = null
        }
      },
      endTimeDateChange (value) {
        if (value) {
          this.queryParam.endTime = (Date.parse(new Date(value)) / 1000) + 57599
        } else {
          this.queryParam.endTime = null
        }
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      search () {
        this.$refs.dataList.search()
      },
    }
  }
</script>



// WEBPACK FOOTER //
// RenewDataList.vue?2ff34401